export const sliderConstants = {
  CONTROL_TYPE_PREV: "prev",
  CONTROL_TYPE_NEXT: "next",
};
